import { preciseRound } from '../constants';
import getSymbolFromCurrency from 'currency-symbol-map';

export function toLocale(value, fractionDigits = 0) {
    if (value === undefined || Number.isNaN(value)) return '';
    return value.toLocaleString(undefined, {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
    });
}

export function toCurrency(amount, currency, fractionDigits = 0) {
    if (amount === undefined || Number.isNaN(amount)) return '-';
    let sign = '';
    let amountAbs = amount;
    if (amount < 0) {
        sign = '-';
        amountAbs *= -1;
    }

    const currencySymbol = getSymbolFromCurrency(currency);
    return `${sign}${currencySymbol}${toLocale(amountAbs, fractionDigits)}`;
}

// Display a percentage given a number in the format 0.xxxx
export function toPercent(number, multiplyBy100 = true) {
    if (number === undefined || Number.isNaN(number)) return '-';
    const val = multiplyBy100 ? number * 100 : number;
    return `${preciseRound(val, 0)}%`;
}

export function clearSpecialCharacters(string) {
    const charsToClear = ['£', '\u00a3', '€', '\u20ac'];
    let cleanString = string;
    charsToClear.forEach((char) => {
        cleanString = cleanString.replace(char, '');
    });
    return cleanString;
}
